export {
  playInputSound,
  playButtonClickSound,
  playButtonDialogClickSound,
  playDropdownClickSound,
  playTabClickSound,
} from '@lst/web2clientapi/sound';
